module.exports = __webpack_public_path__ + "img/5-mbs.3ac1027d.png";